module.exports = __webpack_public_path__ + "img/Frame (2).25b9a33b.png";